import React from 'react'

const PlanningPage = () => {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold mb-4">Planning Page</h1>
      <p>This is a placeholder for the Planning page.</p>
    </div>
  )
}

export default PlanningPage